import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import Menu from '../components/Menu';
import { useApp } from '../context/AppContext';
import About from '../pages/About';
import Geography from '../pages/Geography';
import HoleDashboard from '../pages/HoleDashboard';
import Home from '../pages/Home';
import Leaderboard from '../pages/Leaderboard';
// import PlayerDashboard from '../pages/PlayerDashboard';
import Scoreboards from '../pages/Scoreboards';

import { Overlay } from './styles';
import BonusGames from '../pages/BonusGames';

const Routes: React.FC = () => {

  const {showFilter} = useApp()

  return (
    <BrowserRouter>
      {/* <FilterComponent /> */}
      <Menu />
      <Overlay isOpen={showFilter}/>
      {/* <ActionButton /> */}
      <Switch>
        <Redirect exact from="/" to={`/home`} />
        <Route path="/home"><Home /></Route>
        <Route path="/about"><About /></Route>
        <Route path="/leaderboard" component={Leaderboard} />
        <Route path="/scoreboards" component={Scoreboards} />
        <Route path="/holedashboard" component={HoleDashboard} />
        {/* <Route path="/playerdashboard" component={PlayerDashboard} /> */}
        <Route path="/scoreboards" component={Scoreboards} />
        <Route path="/geography" component={Geography} />
        <Route path="/bonus-games" component={BonusGames} />
       {/* <Route path="/leaderboard" component={Leaderboard} />
        <Route path="/scoreboards" component={Scoreboards} />
        <Route path="/selections" component={Selections} />
        <Route path="/geography" component={Geography} />
        <Route path="/whatif" component={Whatif} />
        <Route path="/predictions" component={Predictions} />
        <Route path="/emotions" component={Emotions} /> */}
      </Switch>
      {/* <Footer /> */}
    </BrowserRouter>
  );
};

export default Routes;
